import uuid from 'uuid';
import { Vue, Options } from 'vue-class-component';

export interface IVDEFunction {
  ref: any;
  title: string;
  type: string;
  selectTypes: any;
}

@Options({
  name: 'ModalAddEditVdeFunction',
  props: {
    vdeFunction: {
      type: Object,
    },
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    isVisible: function (newValue) {
      this.isDialogVisible = newValue;
    },
    vdeFunction: function (value) {
      if (!value) return;
      if (!value.ref) value.ref = { _key: uuid.v4() };
      if (!value.ref._key) value.ref._key = uuid.v4();
    },
  },
  emits: ['hide-dialog', 'confirm'],
})
export default class ModalAddEditVdeFunction extends Vue {
  isVisible!: boolean;
  isDialogVisible = false;
  vdeFunction!: IVDEFunction;

  get validTypes() {
    return Object.keys(this.vdeFunction.selectTypes).reduce((t, k) => {
      if (!isNaN(+k)) {
        t.push({
          name: this.vdeFunction.selectTypes[k],
          code: +k,
        });
      }
      return t;
    }, [] as any);
  }
  mounted() {
    this.isDialogVisible = !!this.isVisible;
  }

  handleHideDialog() {
    this.isDialogVisible = false;
  }
  handleConfirm() {
    this.isDialogVisible = false;
  }

  doHideDialog() {
    this.$emit('hide-dialog');
  }

  doConfirm() {
    if (this.vdeFunction.ref.id === 0) this.$emit('confirm', this.vdeFunction);
    this.handleHideDialog();
  }
}
